define("shared/modifiers/draggable", ["exports", "@fullcalendar/core", "@fullcalendar/interaction", "ember-modifier"], function (_exports, _core, _interaction, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@fullcalendar/core",0,"@fullcalendar/interaction",0,"ember-modifier"eaimeta@70e063a35619d71f
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  var _emitMouseEvent = /*#__PURE__*/new WeakSet();
  var _isValidFunction = /*#__PURE__*/new WeakSet();
  var _useCopiedElement = /*#__PURE__*/new WeakSet();
  class DraggableModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _useCopiedElement);
      _classPrivateMethodInitSpec(this, _isValidFunction);
      // Note: Required as fullcalendar's ThirdPartyDraggable API requires document dispatched mouse events to work, which are
      // disabled during drag events (see @fullcalendar/interaction/main.js)
      _classPrivateMethodInitSpec(this, _emitMouseEvent);
      _defineProperty(this, "fullCalendarDraggableElement", void 0);
    }
    get fullCalendar() {
      return document.querySelector('#calendar');
    }
    get model() {
      return this.args.named.model;
    }
    get droppableClassName() {
      return this.args.named.droppableClassName;
    }
    get cssClassName() {
      return this.args.named.cssClassName;
    }
    get onDragStart() {
      return this.args.named.onDragStart;
    }
    get onDragEnd() {
      return this.args.named.onDragEnd;
    }
    get isFullCalendarDraggable() {
      return this.args.named.isFullCalendarDraggable;
    }
    get isDisabled() {
      return this.args.named.isDisabled;
    }
    get useCopy() {
      return this.args.named.useCopy;
    }
    didReceiveArguments() {
      if (this.isDisabled) {
        this.fullCalendarDraggableElement?.destroy();
        return;
      }
      if (this.isFullCalendarDraggable) {
        // Note: Tracking this so it can be removed if the draggable element is disabled
        this.fullCalendarDraggableElement = new _interaction.ThirdPartyDraggable(this.element);
      }
      this.dragStart = this.dragStart.bind(this);
      this.dragEnd = this.dragEnd.bind(this);
      this.element.addEventListener('dragstart', this.dragStart);
      this.element.addEventListener('dragend', this.dragEnd);
      this.element.setAttribute('draggable', 'true');
    }
    dragStart(event) {
      if (this.isFullCalendarDraggable) {
        // Note: Required to allow mouse coordinates to be tracked across browsers (Firefox will not have
        // coordinates available on drag events)
        this.fullCalendar?.addEventListener('dragover', event => _classPrivateMethodGet(this, _emitMouseEvent, _emitMouseEvent2).call(this, 'mousemove', event));
      }
      if (this.useCopy) {
        _classPrivateMethodGet(this, _useCopiedElement, _useCopiedElement2).call(this, event);
      }
      const targets = document.getElementsByClassName(this.droppableClassName);
      for (const t of targets) {
        t.classList.add(this.cssClassName);
      }
      if (_classPrivateMethodGet(this, _isValidFunction, _isValidFunction2).call(this, this.onDragStart)) {
        this.onDragStart.call(this, event);
      }
    }
    dragEnd(event) {
      if (this.isFullCalendarDraggable) {
        // Note: Required to allow mouse coordinates to be tracked across browsers (Firefox will not have
        // coordinates available on drag events)
        this.fullCalendar?.removeEventListener('dragover', event => _classPrivateMethodGet(this, _emitMouseEvent, _emitMouseEvent2).call(this, 'mousemove', event));
        _classPrivateMethodGet(this, _emitMouseEvent, _emitMouseEvent2).call(this, 'mouseup', event);
      }
      const targets = document.getElementsByClassName(this.droppableClassName);
      for (const t of targets) {
        t.classList.remove(this.cssClassName);
      }
      if (_classPrivateMethodGet(this, _isValidFunction, _isValidFunction2).call(this, this.onDragEnd)) {
        this.onDragEnd.call(this, event);
      }

      // Remove copied element container if it exists
      const copiedElementContainer = document.getElementById('copied-element-container');
      copiedElementContainer?.remove();
    }
    willDestroy() {
      this.element.removeEventListener('dragstart', this.dragStart);
      this.element.removeEventListener('dragend', this.dragEnd);
    }
  }
  _exports.default = DraggableModifier;
  function _emitMouseEvent2(eventType, event) {
    if (this.isFullCalendarDraggable) {
      document.dispatchEvent(new MouseEvent(eventType, event));
    }
  }
  function _isValidFunction2(arg) {
    return typeof arg === 'function';
  }
  function _useCopiedElement2(event) {
    // Create a container for the copy that will not be visible to the user, if element
    // already exists, use existing element
    const existingCopiedElementContainer = document.getElementById('copied-element-container');
    const copiedElementContainer = existingCopiedElementContainer ?? document.createElement('div');
    if (!existingCopiedElementContainer) {
      copiedElementContainer.classList.add('cLIB--boardItemContainer--dragged');
      copiedElementContainer.setAttribute('id', 'copied-element-container');
      document.querySelector('body')?.appendChild(copiedElementContainer);
    }

    // Create the copied element, add the 'drag-copy' class, and append it to the container
    const copiedElement = this.element.cloneNode(true);
    copiedElement.classList.add('cLIB--boardItem--dragged');
    copiedElementContainer.appendChild(copiedElement);

    // Set the copied element as the 'dragImage'
    event.dataTransfer?.setDragImage(copiedElement, 24, 24);
  }
});